import React from 'react'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux"

const AuthenticatedRoute = props => {
    return props.loggedUser ?
            props.component :
            <Redirect from="/" to="/login" />
}

const mapStateToProps = state => {
    return {
        loggedUser: state.userReducer.user
    }
}

export default connect(mapStateToProps)(AuthenticatedRoute);


// WEBPACK FOOTER //
// ./src/helpers/authentication/AuthenticatedRoute.js